module.exports = __webpack_public_path__ + "img/button-web3-disabled.46c1b437.svg";